import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfServicePage = () => (
  <div style={{ backgroundColor: '#0a0a0a', color: 'white', minHeight: '100vh', padding: '4rem 2rem' }}>
    <nav style={{ marginBottom: '4rem', textAlign: 'center' }}>
      <Link to="/" style={{ display: 'inline-flex', alignItems: 'center', gap: '0.5rem', textDecoration: 'none' }}>
        <span style={{ fontSize: '1.5rem' }}>🧠</span>
        <span style={{ fontSize: '1.5rem', fontWeight: 'bold', color: '#e07a5f' }}>WhyDidItDie</span>
      </Link>
    </nav>

    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h1 style={{ fontSize: '3rem', marginBottom: '2rem', color: '#e07a5f', textAlign: 'center' }}>Terms of Service</h1>

      <div style={{ backgroundColor: 'rgba(255,255,255,0.05)', padding: '2rem', borderRadius: '12px', marginBottom: '2rem' }}>
        <p style={{ marginBottom: '1rem' }}><strong>Last updated: June 4, 2025</strong></p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>1. Acceptance of Terms</h3>
        <p>
          By accessing or using WhyDidItDie, you agree to be bound by these Terms of Service, our Privacy Policy, and any additional policies made available. 
          If you do not agree, please do not use the platform.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>2. Use of the Platform</h3>
        <p>
          WhyDidItDie is designed to help users diagnose, analyze, and improve their digital advertising campaigns. 
          You may only use the platform for lawful purposes and in accordance with these terms.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>3. Account Access</h3>
        <p>
          You are responsible for safeguarding your login credentials. You agree to notify us immediately of any unauthorized use of your account. 
          We reserve the right to suspend or terminate accounts that violate our terms or compromise platform integrity.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>4. Data Permissions</h3>
        <p>
          When you connect external ad platforms (like Meta, Google, LinkedIn), you authorize us to access relevant data solely for the purpose 
          of providing analytics, diagnostics, and improvement recommendations.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>5. Intellectual Property</h3>
        <p>
          All content, code, branding, and data models on WhyDidItDie are the intellectual property of the platform. 
          You may not duplicate, distribute, or repurpose any part of it without express permission.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>6. Payment & Subscription</h3>
        <p>
          Some features may require a paid plan. You agree to the pricing and billing terms set at the time of purchase. 
          We reserve the right to modify pricing with reasonable notice.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>7. Termination</h3>
        <p>
          We may terminate or suspend your access to the platform without notice if you violate any terms. 
          Upon termination, your right to access the platform and associated data will cease.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>8. Disclaimer of Warranty</h3>
        <p>
          WhyDidItDie is provided “as is” without warranties of any kind. 
          We do not guarantee specific results, uptime, or platform compatibility across all devices.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>9. Limitation of Liability</h3>
        <p>
          Under no circumstances shall WhyDidItDie or its operators be liable for any indirect, incidental, or consequential damages 
          arising from your use of the platform.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>10. Refund Policy</h3>
        <p>
          Due to the digital and immediate nature of our services, all sales on WhyDidItDie are final and non-refundable. 
          Refunds may be issued only in limited cases such as duplicate payments, accidental unused purchases reported within 24 hours, 
          or verified technical issues that prevent access to the platform and cannot be resolved within 7 business days. 
          To request a review, contact us at <a href="mailto:support@whydiditdie.com" style={{ color: '#e07a5f' }}>support@whydiditdie.com</a>.
        </p>

        <h3 style={{ marginTop: '2rem', color: '#e07a5f' }}>11. Contact Us</h3>
        <p>
          For questions or support, contact us at <a href="mailto:support@whydiditdie.com" style={{ color: '#e07a5f' }}>support@whydiditdie.com</a>.
        </p>
      </div>

      <div style={{ textAlign: 'center' }}>
        <Link to="/homepage" style={{ color: '#e07a5f', textDecoration: 'none', fontSize: '1.1rem' }}>← Back to Home</Link>
      </div>
    </div>
  </div>
);

export default TermsOfServicePage;
